import { useState } from 'react';
import { Stack, IconButton, Tooltip } from '@mui/material';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import VoiceOverOffIcon from '@mui/icons-material/VoiceOverOff';
import {
  isSoundOn, setSoundOn, isVoiceOn, setVoiceOn,
  unlockAudio, previewSound, previewVoice,
} from '../utils/sound';

// Floating sound/voice toggles, shown on the game screens. Positioned fixed so it
// works the same across mobile and desktop and in every game mode.
export default function SoundControls() {
  const [sound, setSound] = useState(isSoundOn());
  const [voice, setVoice] = useState(isVoiceOn());

  const toggleSound = () => {
    const next = !sound;
    setSound(next);
    setSoundOn(next);
    unlockAudio();
    if (next) previewSound();
  };

  const toggleVoice = () => {
    const next = !voice;
    setVoice(next);
    setVoiceOn(next);
    if (next) previewVoice();
  };

  return (
    <Stack
      direction="row"
      sx={{
        position: 'fixed',
        top: 8,
        right: 8,
        zIndex: 1300,
        bgcolor: 'rgba(0,0,0,0.35)',
        borderRadius: 999,
        p: 0.25,
      }}
    >
      <Tooltip title={sound ? 'Sound effects on' : 'Sound effects off'}>
        <IconButton onClick={toggleSound} size="small" sx={{ color: 'white' }} aria-label="toggle sound effects">
          {sound ? <VolumeUpIcon /> : <VolumeOffIcon />}
        </IconButton>
      </Tooltip>
      <Tooltip title={voice ? 'Announce moves on' : 'Announce moves off'}>
        <IconButton onClick={toggleVoice} size="small" sx={{ color: 'white' }} aria-label="toggle move announcements">
          {voice ? <RecordVoiceOverIcon /> : <VoiceOverOffIcon />}
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
